import React from "react";
import PhoneInput from "react-phone-number-input";
import { isPossiblePhoneNumber } from "libphonenumber-js";

const pageProps = JSON.parse(
  (document.querySelector("#app") as HTMLElement).dataset.page!
).props;

export interface PhoneInputComponentProps {
  value: any[];
  onChange: (values: any[]) => void;
}

export default function PhoneInputComponent({
  value,
  onChange,
}: PhoneInputComponentProps) {
  const phoneValue: string = value[0] ?? "";
  const isValid =
    !!phoneValue &&
    isPossiblePhoneNumber(
      phoneValue[0] === "+" ? phoneValue : `+${phoneValue}`
    );

  return (
    <PhoneInput
      className="w-100"
      placeholder="Enter a value"
      countrySelectProps={{ className: "form-select" }}
      numberInputProps={{
        className: `form-control ${isValid ? "" : "border-secondary-subtle"}`,
        title: isValid ? "Number is valid" : "Number is not valid",
      }}
      defaultCountry={pageProps.defaultCountry.country_code || "GB"}
      value={phoneValue}
      onChange={(val: string | undefined) => onChange([val])}
    />
  );
}
